<template>
  <div class="address_big">
    <div style="width:1260px;margin:0 auto">
      <div class="address_top">
        <div class="title">礼包信息</div>
        <div class="address_text">
          <div class="left">
            <div class="box_i">
              <span class="box_name" style="color:#666666">礼包名称</span>
              <span style="color:#666666" v-if='user.festival&&user.festival.id!=$store.state.hidePriceid'>礼包价格</span>
            </div>
            <div class="box_i" v-for='(item,index) in order_detail.festivalPackageJson' :key='index'>
              <span class="box_name">{{item.name}}</span>
              <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600" v-if='user.festival.id!=$store.state.hidePriceid'>
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                <span style="color:#FB3F45">{{item.standardPrice/100}}</span>
                <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
            </div>
          </div>
          <div class="right" style="width:200px;" v-if='user.festival&&user.festival.id!=$store.state.hidePriceid'>
            <span>运费：</span>
            <div>
              <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600">
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                <span style="color:#FB3F45">{{order_detail.freightPrice/100}}</span>
                <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
            </div>
          </div>
          <div class="right" v-if='user.festival&&user.festival.id!=$store.state.hidePriceid'>
            <span>应支付：</span>
            <div>
              <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600">
                <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                <span style="color:#FB3F45">{{order_detail.totalPrice/100}}</span>
                <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //选择卡 -->
       <div class="address_bottom sps">
       
        <div class="lists">
          <div class="list_top">
            <span style="width:700px;">选择支付方式</span>
          </div>
          <div class=" ">
            <div class="list_bottom k_big" v-if='confirm_k_list.length>0'>
              <div class="k_box k_boxs" :class="item.show?'k_boxs':''" v-for='(item,index) in confirm_k_list' v-if="(index<show_index&&item.payType=='CARD')||index==0" :key='index' style="width:280px;height:120px;border:1px solid #E6E6E6">
                <!-- <div><Checkbox v-model="item.show" :disabled="index==0||order_price==0"></Checkbox></div> -->
                <div style="width:100%;">
                  <div>
                    <span style="font-size:18px;color:#0A1132;font-weight:600">{{item.ticketCardNo}}</span>
                    
                  </div>
                  
                  <div class="k_bl">
                    <span style="color:#5B5D66">{{item.productName}}</span>
                    <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600" v-if='user.festival.id!=$store.state.hidePriceid'>
                      <span>抵扣</span>
                      <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                      <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                      <span style="color:#FB3F45">{{item.payAmount?item.payAmount/100:0}}</span>
                      <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
                    </div>
                  </div>
                  <p style="color:#5B5D66;font-size:12px;">有效期：{{item.cardDate}}</p>
                </div>
              </div>
              
            </div>
            <div class="box_x" style="margin-top:20px">
              <!-- <div class="add_k" @click="bindaddklist" v-if="confirm_k_list.length!=1&&order_price!=0"><span>+</span><span>添加券</span></div> -->
              <div class="add_k" @click="bindaddklist"><span>+</span><span>添加券</span></div>
              <span style="color:#666666;font-size:14px;" v-if="confirm_k_list.length>4" @click="show_index=50">显示更多></span>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:right;width:1260px;margin:20px auto;">
      <p
        v-if="!address_show"
        style="color:#FD2F51;margin-bottom:10px;"
      >{{show_address?ts_show:'暂无收货地址'}}</p>
      <div v-if="user&&user.festival&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid" style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px">
        <span></span>
        <div class="sale_price" style="padding-left:10px" >
          <span style="color:#5B5D66;">还需支付：</span>
          <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
          <img style="width:16px;height:16px;background:none;" v-if="!user.festival||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
          <span style="font-size:16px;color:#FD5430;font-weight:600">{{order_price}}</span>
          <span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
        </div>
      </div>
      
      <span
        v-if="!loadingg&&(order_price!=order_detail.salePrice/100||(user.festival&&user.festival.id==$store.state.payment0))&&pay_show"
        @click="bindconfirm"
        style="cursor: pointer;height:42px;width:144px;background:#F3A251;color:white;display: inline-block;line-height:42px;text-align:center"
      >确认支付</span>
      <span
        v-loading="loadingg"
        element-loading-text
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        v-else
        class="binddh"
        style="cursor: pointer;height:42px;width:144px;background:#F3A251;color:white;display: inline-block;line-height:42px;text-align:center"
      >确认支付</span>
    </div>
    <div class="tk_box" v-if="add_k_show">
			<p class="bj"></p>
			<div class="add_kj" style="height:450px;">
				<div class="add_kj_top">
					<span>添加卡劵</span>
          <img src="../../assets/img/cancel.png"  alt="" @click="add_k_show=false">
				</div>
        <div v-if='add_type==1'>
            <div class="add_kj_nav">
                <span :class="add_nav==1?'add_nav_active':''" @click='add_nav=1'>{{user.festival&&user.festival.id=='2058'?'卡券':'品诺券'}}</span>
                <span style="margin-left:24px;" :class="add_nav==2?'add_nav_active':''" @click='add_nav=2'>电子劵</span>
                <!-- <span :class="add_nav==2?'add_nav_active':''" @click='bindnav(2)'>已绑定卡</span> -->
              </div>
              <div class='add_kj_center' v-if="add_nav==1">
                <div class="center_box">
                  <span>券号：</span>
                  <input type="" name="" id="" v-model="k_number" value="" placeholder="请输入您的券号"/>
                </div>
                <div class="center_box">
                  <span>密码：</span>
                  <input type="password" name="" id="" v-model="k_password" value="" placeholder="请输入您的密码"/>
                </div>
              </div>
              <div class='add_kj_center' v-if="add_nav==2">
                <div class="center_box" style="padding:0 10px;">
                  <span>电子劵：</span>
                  <input style="width:300px" type="" name="" id="" v-model="kj_number" value="" placeholder="请输入电子劵号"/>
                </div>
              </div>
            
              <div class="kj_bottom">
                <div>
                  <span @click="bindadd">添加</span>
                  <span @click="add_type=2">取消</span>
                </div>
              </div>
        </div>
        <!-- //选择 -->
				<div v-else style="padding:0 20px;">
            <div @click="add_type=1" style="cursor: pointer;width:90px;height:32px;background:#F3A251;line-height:32px;color:white;margin:10px;">
              <span class="jhjh" style="font-size:16px;color:#EE8F36;margin-right:4px;">+</span>
              <span>添加卡券</span>
            </div>
            <div class="k_list_box">
              <div class="bbb_box dis-f" v-for='(item,index) in card_list' :key='index' @click="bindseletek(index)">
                  <div><Checkbox v-model="item.show" :disabled="(index==0&&(user.festival&&user.festival.id!=$store.state.payment0))||(user.festival&&user.festival.id==$store.state.payment0&&item.balance==0)"></Checkbox></div>
                  <!-- <div><Checkbox></Checkbox></div> -->
                  <div style="width:90%;">
                    <div class="dis-f">
                      <div style="display: flex;align-items: center;">
                        <span>{{item.ticketCardNo}}</span>
                        <!-- <div style="display: inherit;" v-if="item.cardSetting.moduleSupport.supportItem==false||item.cardSetting.multipleCardPay.supportItem==false||item.cardSetting.differencePay.supportItem==false">
                            <span v-if='item.cardSetting&&!item.cardSetting.moduleSupport.supportItem' style="color:#fb3f45;margin-left:6px;">不支持购买商品</span>
                            <span v-if='item.cardSetting&&item.cardSetting.moduleSupport.supportItem&&!item.cardSetting.multipleCardPay.supportItem' style="color:#fb3f45;margin-left:6px;">不支持多卡支付</span>
                            <span v-if='item.cardSetting&&item.cardSetting.moduleSupport.supportItem&&item.cardSetting.multipleCardPay.supportItem&&!item.cardSetting.differencePay.supportItem' style="color:#fb3f45;margin-left:6px;">不支持补差</span>
                        </div> -->
                      </div>
                      
                      <div style="display:flex;align-items:center;color:#FB3F45;font-weight:600" v-if='user.festival.id!=$store.state.hidePriceid'>
                        <img style="width:16px;height:16px;" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
                        <img src="../../assets/img/pindou.png" v-if="!user.festival||!user.festival.priceSymbol" alt="" style="width:16px;height:16px;">
                        <span style="color:#FB3F45">{{item.balance/100}}</span>
                        <span style="color:#FB3F45" v-if="user.festival&&user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
                      </div>
                    </div>
                    <div class="dis-f" style="margin-top:10px;">
                      <span class="color:#999999">{{item.productName}}</span>
                      <span class="color:#999999">有效期：{{item.cardDate}}</span>
                    </div>
                  </div>
              </div>
            </div>
            <div class="kj_bottom" style="left:0;margin-top:30px;bottom:0;">
              <div style="width:100%;height:32px;">
                <span @click="bindadd_qr" style="width:90%">确认选择</span>
              </div>
            </div>
        </div>
			</div>
		</div>
    <div class="tk_box" v-show="centerDialogVisible">
			<p class="bj"></p>
			<div class="add_kj" style="width:390px;">
				<p style="margin-top:10px;font-size:16px;font-weight: 600;">支付</p>
				<img @click="bindggbb" class="ggbb" src="../../assets/images/sscc.png"/>
				<div id="qrCode" ref="qrCodeDiv"></div>
				<div class="an">
					<!--<span @click="bindqxzf">取消支付</span>-->
					<span @click="bindzfcg" style="margin-right:0;color:rgb(241, 74, 97);font-size:16px;border-color: rgb(241, 74, 97);">支付成功</span>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import nav from "../nav";
import getCurrentCityName from "../../js/map";
import links from "../../js/link_parameters";
import wechatAuth from "../../wechatAuth";
import { Message, Loading } from "element-ui";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import $ from "jquery";
import QRCode from 'qrcodejs2';
import axios from "axios";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Tables from "../../components/tables/tables";
import echarts from "echarts";
import { formatDate, formatTimeToStr } from "../../js/data";
export default {
  name: "index",
  components: {
    Tables
  },
  data() {
    var vm = this;
    return {
      add_type:2,
      centerDialogVisible:false,
      loadingg:false,
      show_index:4,
      list:'',
      kj_number:'',
      k_number:'',
      k_password:'',
      add_k_show:false,
      add_nav:1,
      single:'',
      remark:'',
      c_time_list:[],
      qhjz_show:false,
      sjVisible:false,
      gift_list: "",
      datas: {},
      add_show: true,
      mr_checked: false,
      gift_details: "",
      tpVisible: false,
      gift_id: this.$route.query.id ? this.$route.query.id : "",
      cart_show:this.$route.query.cart_show ? this.$route.query.cart_show : false,
      address_list: "",
      show_address: "",
      add_index: null,
      loadingg: false,
      isDefault: false,
      loading: false,
      datas: {
        consignee: "",
        mobile: "",
        province: "",
        city: "",
        district: "",
        town: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        townId: "",
        detail: "",
        isDefault: false
      },
      dq_list: "", //地区
      city_s: "",
      city_list: "",
      city_c: "",
      qy_list: "",
      xz_list: "",
      city_q: "",
      city_x: "",
      province: {},
      city: {},
      district: {},
      town: {},
      zq_show: {}, //选中的专区
      address_show: true,
      ts_show: "",
      time_list:[],
      time_show:'',
      id_show:'',
      xz_show_time:'',
      user:'',
      all_price:0,
      cart_list:[],
      card_list:[],
      order_detail:'',
      k_number:'',
      k_password:'',
      kj_number:'',
      order_price:'',
      pay_show:true,
      userinfo:'',
      order_id: this.$route.query.order_id ? this.$route.query.order_id : "",
      confirm_k_list:[]
      
    };
  },
  computed: {},
  created() {},
  mounted() {
    var user = sessionStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
    } else {
      this.$router.push({ path: "/login" });
    }
    console.log(JSON.parse(user))
    
    var userinfo = this.$cookies.get("pn_user")
			if(userinfo){
				this.userinfo=userinfo
      }
    var order_detail = sessionStorage.getItem("order_detail");
    var detail = order_detail?JSON.parse(order_detail):''
    if(detail){
       detail.festivalPackageJson = (typeof(detail.festivalPackageJson)=='string')?JSON.parse(detail.festivalPackageJson):detail.festivalPackageJson
      this.order_detail = detail
      this.order_price = detail.totalPrice/100
      console.log(detail.salePrice/100)
      console.log(detail)
    }else{
      this.bindorder_detail()
    }
   this.getUser(true)
    
    
  },
  methods: {
    bindaddklist(){
      this.add_k_show=true
      this.add_type=2
      var confirm_k_list = this.confirm_k_list
      var card_list = this.card_list
      confirm_k_list.forEach((item)=>{
        card_list.forEach((item1,index)=>{
          item1.show=false
            if(item.ticketCardNo == item1.ticketCardNo||index==0){
              item1.show=true
            }
        })
      })
      console.log(card_list)
      this.card_list = card_list
    },
    bindorder_detail(){
        console.log(this.user)
				var data = {
					parentOrderUid: this.order_id,
				}
				var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
				this.$server.getItemOrder(data,headers).then(res => {
					console.log(res)
					var list = res.data.default
					list.addressJson=JSON.parse(list.addressJson)
					list.externalOrderJson=list.externalOrderJson?JSON.parse(list.externalOrderJson):''
          list.internalOrderJson=list.internalOrderJson?JSON.parse(list.internalOrderJson):''
          list.festivalPackageJson=list.festivalPackageJson?JSON.parse(list.festivalPackageJson):''
          
					var sp_list={}
					list.orderItems.forEach((item,index)=>{
						list.externalOrderJson.childOrders.forEach(itemf=>{
							itemf.sku.forEach(itemg=>{
								if(itemg.skuId==item.skuId){
									item.cakeTime=itemg.cakeTime
								}
							})
						})
					})
					list.subOrders.forEach((items)=>{
						items.s_list=[]
						list.orderItems.forEach((item,index)=>{
							sp_list[item.skuId]=item.skuName
							console.log(sp_list)
							// var ddd={item.skuId=item.skuName}
							if(item.skuId==0){
								list.orderItems.splice(index,1)
								return
							}
							
							console.log(typeof(item.itemSkuJson)=='string')
							item.itemSkuJson = typeof(item.itemSkuJson)=='string'?JSON.parse(item.itemSkuJson):item.itemSkuJson
							item.attrJson = typeof(item.attrJson)=='string'?JSON.parse(item.attrJson):item.attrJson
							item.subGoodsJson = typeof(item.subGoodsJson)=='string'?JSON.parse(item.subGoodsJson):item.subGoodsJson
							console.log(item)
								
								if(item.subOrderId == items.id){
									item.orderStatus=items.orderStatus
									item.uuid=items.uid
									item.shippingStatus=items.shippingStatus
									items.s_list.push(item)
								}
							})
					})
					console.log(list)
					this.sp_list=sp_list
          this.order_detail= list
          this.order_price = list.totalPrice/100
				})
			},
    bindseletek(index){
      console.log(this.card_list)
      console.log(index)
      if(index!=0||(this.user.festival&&this.user.festival.id==this.$store.state.payment0&&this.card_list[index].balance>0)){
          this.card_list[index].show=!this.card_list[index].show
      }
      
    },
    bindggbb(){
      location.reload()
    },
    bindzfcg(){
      this.$router.push({
        path: "/result",
        query: {
          id:this.order_detail.uid,
          name:this.order_detail.festivalPackageJson[0].name
        }
      });
      this.webStatistics.trackEvent('orderBuy')
    },
    bindewm(e){
//				console.log('二维码')/
		        new QRCode(this.$refs.qrCodeDiv, {
		          text: e.codeUrl,
		          width: 200,
		          height: 200,
		          colorDark: "#333333", //二维码颜色
		          colorLight: "#ffffff", //二维码背景色
//		          correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
		        })
		        this.centerDialogVisible=true
			},
    bindaddTrustedDevice(){//添加信用设备
      var that = this
      let fpPromise = FingerprintJS.load()
      fpPromise.then(fp => fp.get()).then(result => {
        console.log(result.visitorId)
        let data  = {
          deviceId:result.visitorId,
          parentOrderUid:this.order_detail.uid
        }
        that.$server.addTrustedDevice(data).then(res=>{
          localStorage.setItem("DeviceId",result.visitorId)
        })
      })
      
    },
    bindconfirm(){
      this.loadingg=true
      var that = this
      console.log('用户信息',this.userinfo)
      var data={
        parentOrderUid:this.order_detail.uid,
        checkPwd:false,
        userOpenId:this.userinfo?this.userinfo.openid:'',
        userInfo:JSON.stringify(this.userinfo),
        clientPlatform:2,
      }
      var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
      this.$server.startpay(data,headers).then(res => {
						console.log(res)
        if(res.code==0){
             this.$router.push({
              path: "/result",
              query: {
                id:this.order_detail.uid,
                name:this.order_detail.festivalPackageJson[0].name
              }
            });
            this.bindaddTrustedDevice()
            this.webStatistics.trackEvent('orderBuy')
        }else{
          if(res.code==10){
            that.bindewm(res.data.default)
          }else{
            this.$alert(res.msg, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                       that.$router.push({
                        path: "/order_detail",
                        query: {
                          id:that.order_detail.uid,
                          name:that.order_detail.festivalPackageJson[0].name
                        }
                      });
                  }
                });
          }
        }
      })
				
    },
    bindadd(){
				if(this.add_nav==1){
          this.k_number = this.k_number.replace(/(^\s*)|(\s*$)/g, "")
					this.getkj()
				}
				if(this.add_nav==2){
          //点击已添加的卡劵
          if(this.kj_number!=''&&this.kj_number.length==17){
            this.kj_number = this.kj_number.replace(/(^\s*)|(\s*$)/g, "")
            var k_number=this.kj_number.slice(0,11)
            var k_password=this.kj_number.slice(11,17)
            this.k_number=k_number
            this.k_password=k_password
          }else{
            this.$message({
			          message: '卡券不能为空',
              });
              return
          }
					this.getkj()
				}
      },
    getkj(){//查询卡劵
				if(this.k_number!=''&&this.k_password!=''){
					var data={
						cardNo:this.k_number,
						cardPwd:this.k_password,
            orderUid:this.order_detail.uid,
            festivalUid:this.user.festival.uid
          }
          var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
					this.$server.verifyTicketCard(data,headers).then(res => {
						console.log(res)
						if(res.code==0){
              if(res.data.default.balance==0){
                this.$message({
					          	message: '余额为0，不能添加',
					          	type:'error'
                  });
                  return
              }
							this.add_show=false
							var data = res.data.default
							var num = 0
							this.card_list.forEach(item=>{
								if(item.ticketCardNo==data.ticketCardNo){
									num++
								}
              })
              console.log(num)
							if(num==0){
								data.password=this.k_password
								// if(this.order_price==0){
								// 	data.show=false
								// }else{
									data.show=true
                // }
                
                this.card_list.push(data)
                this.add_type=2
                
              }else{
                this.$message({
					          	message: '该卡已添加',
					          	type:'error'
					        });
              }
              
						}else{
							this.$message({
					          	message: res.msg,
					          	type:'error'
					        });
						}
					})
				}else{
					this.$message({
			          message: '账户密码不能为空',
			        });
				}
      },
    bindadd_qr(){
      this.createpays()
    },
    createpays(index){//创建支付方式
        var that = this
        var list = JSON.parse(JSON.stringify(this.card_list))
        var ticketCardInfo = ''
        list.map((item,index) => {
          if(item.show&&item.cardSetting.cardBaseConfig.specialFestivalCard){
              list.unshift(list.splice(index , 1)[0]);
          }
        })
        console.log(list)
        list.forEach((item)=>{
          if(item.show){
            ticketCardInfo+=item.ticketCardNo+'_'+item.ticketCardPwd+','
          }
        })
        ticketCardInfo = ticketCardInfo.substring(0, ticketCardInfo.length - 1);
        console.log(this.order_detail.uid)
        var data={
          cashType:'WXNATIVE',
          parentOrderUid:this.order_detail.uid?this.order_detail.uid:this.order_id,
          ticketCardInfo:ticketCardInfo,
          clientPlatform:2,
        }
        var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token,
            
					}
				this.$server.createpay(data,headers).then(res => {
					console.log(res)
					if(res.code==0){
           var list=res.data.default
           var price = this.order_detail.totalPrice/100
           var k_nums = 0
           list.forEach((item)=>{
             if(item.payType=='CARD'){
               price-=(item.payAmount/100)
               k_nums+=1
             }
             this.card_list.forEach((item1)=>{
               if(item.ticketCardNo==item1.ticketCardNo){
                 item.productName = item1.productName
                 item.cardDate = item1.cardDate
               }
             })
           })
           if(k_nums==0){
             this.confirm_k_list=[]
           }else{
              this.confirm_k_list=list?list:this.card_list[0]
           }
           
            if(price>=0){
              price = price.toFixed(2)
              this.order_price=price
            }else{
              this.order_price=0
            }
            this.pay_show=true
            this.add_k_show=false
          }else{
            console.log(this.card_list)
            if(res.code==101){
              this.$confirm(res.msg, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                that.$router.push({ path: "/" });
              })
            }else{
              this.$message({
                  message: res.msg,
                  type:'error'
              });
            }
            
            // if(index){
            //   console.log(this.card_list[index].show)
            //   this.card_list[index].show=false
            // }
            
            // this.pay_show=false
          }
				})
    },
    getUser(e){
				var headers = {
						'Content-Type':'application/x-www-form-urlencoded',
						'Authorization': this.user.token
					}
				this.$server.getCardUserBalance({},headers).then(res => {
					console.log(res)
					if(res.code==0){
            var user = this.user;
            this.$store.state.validTimes = res.data.default.validTimes;
            this.$store.state.balance = res.data.default.balance;
            sessionStorage.setItem("user", JSON.stringify(user));
            if(e){
              if(this.user.festival&&this.user.festival.id!=this.$store.state.payment0){
                res.data.default.show=true
                this.confirm_k_list.push(res.data.default)
                console.log('this.confirm_k_list',this.confirm_k_list)
              }else{
                res.data.default.show=false
              }
              this.card_list.push(res.data.default)
              
            }
            this.createpays()
          }
          console.log('卡list',this.card_list)
				})
			},
   
    
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.k_list_box{
  height:300px;
  overflow:auto;
}
.add_kj_center{
  margin:50px 0;
}
.bbb_box{
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  height:70px;
  margin-bottom:20px;
  padding:10px 20px;
}
.dis-f{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.jhjh{
  border-radius: 50%;
  background: white;
  width:16px;
  height:16px;
  display: inline-block;
  line-height: 16px;
}
.k_box{
  cursor: pointer;
}
.box_i{
  display: flex;
  margin-bottom:10px;
  .box_name{
    display: inline-block;
    width:430px;
  }
}
.tk_box{
			width:100vw;
			height:100vh;
			position:fixed;
			top:0;
			left:0;
			.add_kj{
				width:420px;
				height:320px;
				background:white;
				position: absolute;
				top:0;
				bottom:0;
				left:0;
				right:0;
				margin:auto;
				.ggbb{
					width:30px;
					height:30px;
					position: absolute;
          cursor: pointer;
					top:5px;
					right:5px;
				}
				.add_kj_center1{
					overflow-y: auto;
					height:160px;
					padding:0 32px;
					margin-top:10px;
					.ybk_box{
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom:16px;
						span{
							font-size:16px;
							color: #333333;
						}
						div{
							i{
								display: inline-block;
								width:16px;
								height:16px;
								border-radius: 50%;
								border:1px solid #E6E6E6;
							}
						}
					}
				}
				.kj_bottom{
					width:100%;
					position: absolute;
					box-sizing: border-box;
					background:white;
					// bottom:0;
					display: flex;
					justify-content: space-around;
					align-items: center;
					height:52px;
					span{
						font-size:12px;
						cursor: pointer;
            width:72px;
						height:32px;
            display: inline-block;
            border:1px solid #E8E8E8;
            line-height: 32px;
            text-align: center;
					}
					span:nth-child(1){
						background:#F3A251;
						color:white;
						margin-left:15px;
            margin-right:16px;
					}
				}
				.add_kj_center{
					.center_box{
						margin-bottom:16px;
						input{
							height:32px;
							padding:0 16px;
							width:240px;
              margin-left:16px;
							outline: none;
							border:1px solid #E6E6E6;
						}
					}
				}
				.add_kj_nav{
					width:270px;
					height:32px;
					margin:24px auto;
					.add_nav_active{
						background:#FFF4EB!important;
            border-color: #FAC593;
						color:#EE8F36;
					}
					span{
						display: inline-block;
						height:32px;
						line-height: 32px;
						cursor: pointer;
						width:90px;
					  border:1px solid #E6E6E6;
					}
				}
				.add_kj_top{
					height:40px;
					padding:0 16px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					background:#E6E6E6;
					img{
						height:20px;
						width:20px;
						cursor: pointer;
					}
				}
			}
			.bj{
				height:100%;
				width:100%;
				background:#000000;
				opacity: 0.5;
			}
		}
.tk_box{
			text-align: center;
			#qrCode{
				width:49%;
				text-align: center;
				margin:20px auto;
			}
			.an{
				margin-top:20px;
				display: flex;
				justify-content: space-around;
				span{
					display: inline-block;
				    height: 30px;
				    width: 90px;
				    text-align: center;
				    line-height: 32px;
				    cursor: pointer;
				    border: 1px solid white;
				    border-radius: 50px;
				    font-size: 12px;
				}
				span:nth-child(1){
					border: 1px solid #E6E6E6;
				    background: white;
				    margin-right: 24px;
				}
				span:nth-child(2){
					margin-left: 5px;
				    border-color: #F14A61;
				    background: white;
				    color: #F14A61;
				}
			}
		}
.k_boxs{
  border:1px solid #F3A251!important;
  background: #FFF7F0;
}
.k_boxs .k_num{
  color:#F3A251!important;
}
.k_boxs .k_bl{
  border-color: #F3A251;
}

.box_x{
  display: flex;
  align-items: center;
  margin-left:24px;
  margin-bottom:24px;
  cursor: pointer;
}
.add_k{
  width:100px;
  height:32px;
  border:1px solid #E6E6E6;
  display: flex;
  padding:0 10px;
  align-items: center;
  margin-right:24px;
  justify-content: space-around;
}
.k_big{
  display: flex;
  min-height:170px!important;
  align-items: center;
  flex-wrap: wrap;
  padding:24px!important;
  padding-bottom:0!important;
}
.k_box{
  display: flex;
  align-items: center;
  padding:10px;
  margin-right:24px;
  margin-bottom:24px;
}
.k_box:nth-child(4n+4){
  margin-right:0;
}
.k_bl{
  display: flex;
  padding:10px 0;
  margin-bottom:14px;
  align-items: center;
  justify-content: space-between;
  border-bottom:1px solid #E6E6E6;
}
.t_active{
  color:#F3A251;
  border:1px solid #F3A251!important;
}
.xzrq{
  display: flex;
}
.sj_box{
  display: inline-block;
  padding:2px 5px;
  border:1px solid #E6E6E6;
  margin-right:10px;
  margin-bottom:10px;
  cursor: pointer;
}
.binddh {
  opacity: 0.6;
}
.xiugai {
  height: 24px;
  width: 60px;
  text-align: center;
  line-height: 24px;
  border: 1px solid #f3a251;
  color: #f3a251;
  display: inline-block;
  cursor: pointer;
  margin-left: 20px;
}
.dz_top_active {
  border-color: #f3a251 !important;
  background: url("../../assets/img/dz_xz.png") no-repeat right bottom;
}
.dz_box {
  min-height: 87px;
  cursor: pointer;

  border: 1px solid #e6e6e6;
  padding: 14px 16px;
  margin-bottom: 16px;
  .dz_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.add_rights {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
}
.new_adds {
  width: 144px;
  height: 42px;
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.new_add {
  width: 144px;
  height: 42px;
  border: 1px solid rgba(232, 232, 232, 1);
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.address_bottom {
  margin-top: 30px;
}
.lists {
  min-height: 50px;
  border: 1px solid #e6e6e6;
  .rights {
    width: 200px;
    text-align: center;
  }
  .list_bottom {
    padding: 0 24px;
    min-height: 200px;
	.l_boxs:last-child{
		.l_box:last-child {
			border: none;
		}
	}
   
    .l_box {
      display: flex;
      align-items: center;
      padding: 24px 0;
      border-bottom: 1px dotted #cccccc;
    }
  }
  .list_top {
    display: flex;
    color: #909199;
    background: #f5f5f5;
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
  }
}
.select {
  width: 145px;
  height: 32px;
  margin-right: 24px;
}
.address_text {
  min-height: 100px;
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    width: 421px;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 32px;
    .aniu {
      display: flex;
      align-items: center;
    }
    .ljdhs {
      height: 50px;
      width: 186px;
      display: inline-block;
      line-height: 50px;
      margin-left: 10px;
      cursor: pointer;
      text-align: center;
      color: #f3a251;
      border: 1px solid;
      background: #fffaf6;
    }
    .ljdh {
      height: 50px;
      cursor: pointer;
      width: 186px;
      background: #f3a251;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      color: white;
    }
  }
  .left {
    height: 100%;
    width: 738px;
    .boxx11 {
      display: flex;
      justify-content: space-between;
    }
    .boxx {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .boxx1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 47%;
      }
    }
  }
}
.address_top {
  border: 1px solid #e6e6e6;
  margin-top: 32px;
  min-height: 100px;
  width: 100%;
  .title {
    height: 44px;
    width: 100%;
    background: #f5f5f5;
    color: #909199;
    font-size: 16px;
    line-height: 44px;
    padding-left: 22px;
  }
}
.address_big {
  min-height: 87vh;
  border-top: 1px solid #e4e5ed;
  padding-bottom: 50px;
}
</style>